import WorkCycleEvaluationScreen from './WorkCycleEvaluationScreen.js';

export default WorkCycleEvaluationScreen;
